var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4444 10.9H10V15.4H14.4444V10.9ZM13.5556 1V2.8L6.44444 2.8V1L4.66667 1V2.8L3.77778 2.8C2.79111 2.8 2.00889 3.61 2.00889 4.6L2 17.2C2 18.19 2.79111 19 3.77778 19L16.2222 19C17.2 19 18 18.19 18 17.2L18 4.6C18 3.61 17.2 2.8 16.2222 2.8H15.3333V1L13.5556 1ZM16.2222 17.2L3.77778 17.2L3.77778 7.3L16.2222 7.3V17.2Z",
    fill: "#5B768B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldCalendar);
export default __webpack_public_path__ + "static/media/field-calendar.23ae8be0500de646bbe964c0e48f6b2c.svg";
export { ForwardRef as ReactComponent };